import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FreudMultiSelectModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { StatusIconModule } from '../status-icon/status-icon.module';
import { PromptuaryReasonsComponent } from './promptuary-reasons.component';

@NgModule({
	declarations: [PromptuaryReasonsComponent],
	imports: [
		CommonModule,
		FreudMultiSelectModule,
		TranslateModule.forChild(),
		FormsModule,
		StatusIconModule,
	],
	exports: [PromptuaryReasonsComponent],
	providers: [],
})
export class PromptuaryReasonsModule {}
